import { render } from "./Tallas.vue?vue&type=template&id=4f665180&scoped=true"
import script from "./Tallas.vue?vue&type=script&lang=js"
export * from "./Tallas.vue?vue&type=script&lang=js"

import "./Tallas.vue?vue&type=style&index=0&id=4f665180&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f665180"]])

export default __exports__